import React, { useEffect, useState, useMemo } from "react";
import {
  Space,
  Select,
  Tabs,
  message,
  Button,
  Spin,
  Table,
  Radio,
  Checkbox,
  Modal,
  Input,
  Dropdown,
  Menu,
} from "antd";
import { MoreOutlined, EditOutlined, DeleteOutlined,SearchOutlined,UpOutlined,DownOutlined } from "@ant-design/icons";
import "./component/index.scss";
import api from "@/utils/api";
import http from "@/utils/http";
import GroupModal from "./component/GroupModal";
import commonFn from "@/utils/commonFn";
const FinancialDashboard = () => {
  const [ownerOptions, setOwnerOptions] = useState([]);
  const [selectedOwners, setSelectedOwners] = useState([]);
  const [dateType, setDateType] = useState("1");
  const [tabsItems, setTabsItems] = useState([]);
  const [activeTab, setActiveTab] = useState("");
  const [summaryData, setSummaryData] = useState(null);
  const [ownerLoading, setOwnerLoading] = useState(false);
  const [groupLoading, setGroupLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [showZeroRowsMap, setShowZeroRowsMap] = useState({});
  const { Option } = Select;
  const [groupList, setGroupList] = useState([]);
  const [groupModalVisible, setGroupModalVisible] = useState(false);
  const [selectedGroupId, setSelectedGroupId] = useState(null);
  const [editGroupData, setEditGroupData] = useState(null);
  const [modalMode, setModalMode] = useState("create");
  const [ownerSearchText, setOwnerSearchText] = useState("");
  const [filtersCollapsed, setFiltersCollapsed] = useState(false);
const filteredOwners = ownerOptions.filter(owner =>
  owner.name.toLowerCase().includes(ownerSearchText.toLowerCase())
);
  const buildColumns = (dateColumns = []) => [
    { title: "Entity", dataIndex: "entity", align: "center", width: 120 },
    {
      title: "Bank Account #",
      dataIndex: "bankAccount",
      align: "center",
      width: 120,
    },
    { title: "Bank Remark", dataIndex: "remark", align: "center", width: 120 },
    {
      title: "Latest Balance",
      dataIndex: "latestBalance",
      width: 120,
      align: "center",
      render: (value) => commonFn.amountToDollarBracketFn(value),
    },
    ...dateColumns.map((col) => ({
      title: col.label,
      dataIndex: col.key,
      align: "center",
      width: 120,
        isBracketAmountFlag: true,
         render: (value) => commonFn.amountToDollarBracketFn(value ?? 0),
    })),
  ];

  const fetchOwnerOptions = async () => {
    setOwnerLoading(true);
    try {
      const res = await http.get(api.getOwnerDictList_2, {
        params: {
          onlyActive: "1",
        },
      });
      if (res?.code !== "1") {
        message.error(res?.msg || "Load owner failed");
        return;
      }
      setOwnerOptions(res.data || []);
    } finally {
      setOwnerLoading(false);
    }
  };

  const fetchGroupList = async () => {
    setGroupLoading(true);
    try {
      const res = await http.get(api.getBalanShowGroupList);
      if (res?.code !== "1") {
        message.error(res?.msg);
        return;
      }
      setGroupList(res.data || []);
    } finally {
      setGroupLoading(false);
    }
  };
  useEffect(() => {
    fetchOwnerOptions();
    fetchGroupList();
  }, []);

  const fetchSummary = async (ownerId) => {
    setPageLoading(true);
    try {
      const res = await http.get(api.getBankBalanceSummaryList, {
        params: { ownerId, dateType },
      });

      if (res?.code !== "1") {
        message.error(res?.msg || "Load failed");
        return;
      }
      setSummaryData(res.data);
    } finally {
      setPageLoading(false);
    }
  };

  const handleSubmit = async () => {
    if (!selectedOwners.length) {
      return message.warning("Please select owner");
    }
    setSubmitLoading(true);
    try {
      const isAll = selectedOwners.includes("all");

      const ownersForTabs = isAll
        ? ownerOptions
        : ownerOptions.filter((o) => selectedOwners.includes(o.ownerId));

      if (!ownersForTabs.length) return;
      const items = ownersForTabs.map((o) => ({
        key: String(o.ownerId),
        label: o.name,
      }));
      const firstKey = String(ownersForTabs[0].ownerId);
      setTabsItems(items);
      setActiveTab(firstKey);
      setSummaryData(null);
      await fetchSummary(firstKey);
    } finally {
      setSubmitLoading(false);
    }
  };

  const handleOwnerToggle = (ownerId) => {
    setSelectedGroupId(null);
    setSelectedOwners((prev) => {
      if (prev.includes(ownerId)) {
        return prev.filter((id) => id !== ownerId);
      } else {
        return [...prev, ownerId];
      }
    });
  };

  const handleAllOwnersToggle = (checked) => {
    setSelectedGroupId(null);
    if (checked) {
      setSelectedOwners(["all"]);
    } else {
      setSelectedOwners([]);
    }
  };

  const handleGroupSelect = (groupId, ownerIds) => {
    if (selectedGroupId === groupId) {
      setSelectedGroupId(null);
      setSelectedOwners([]);
    } else {
      setSelectedGroupId(groupId);
      const ownerIdList = ownerIds || [];
      setSelectedOwners(ownerIdList);
    }
  };

  // 处理删除 Group
  const handleDeleteGroup = async (groupId) => {
    try {
      const res = await http.post(api.getDeleteBalanGroupList, {
        id: groupId,
      });

      if (res?.code !== "1") {
        message.error(res?.msg || "Delete group failed");
        return;
      }
      message.success("Group deleted successfully");

      // 删除的是当前选中的 Group，才清空选中状态
      if (selectedGroupId === groupId) {
        setSelectedGroupId(null);
        setSelectedOwners([]);
      }

      fetchGroupList();
    } catch (error) {
      message.error("Delete group failed");
    }
  };

  // 处理编辑 Group
  const handleEditGroup = (group) => {
    setEditGroupData(group);
    setModalMode("edit");
    setGroupModalVisible(true);
  };

  // 处理创建 Group - 打开 Modal
  const handleCreateGroup = () => {
    setEditGroupData(null);
    setModalMode("create");
    setGroupModalVisible(true);
  };

  // 关闭 Modal
  const handleCloseModal = () => {
    setGroupModalVisible(false);
    setEditGroupData(null);
  };
  // 获取 Group 的操作菜单
  const getGroupMenu = (group) => (
    <Menu
      onClick={(info) => {
        info.domEvent.stopPropagation();

        if (info.key === "edit") {
          handleEditGroup(group);
          return;
        }

        if (info.key === "delete") {
          Modal.confirm({
            title: "Delete Group",
            content: `Are you sure you want to delete "${group.groupName}"?`,
            okText: "Yes",
            cancelText: "No",
            okType: "danger",
            centered: true,
            onOk: () => handleDeleteGroup(group.id),
          });
        }
      }}
    >
      <Menu.Item key="edit" icon={<EditOutlined />}>
        <span style={{ color: "#2563EB" }}>Edit</span>
      </Menu.Item>

      <Menu.Item key="delete" icon={<DeleteOutlined />}>
        <span style={{ color: "#ff4d4f" }}>Delete</span>
      </Menu.Item>
    </Menu>
  );

  const visibleDateColumns = summaryData?.dateColumns || [];
  const columns = useMemo(() => {
    return buildColumns(visibleDateColumns);
  }, [visibleDateColumns]);

// 判断当前查询结果是否有可展示的银行数据（考虑 showZeroRows 过滤后的结果）
const hasRenderableData = useMemo(() => {
  if (!summaryData?.groups?.length) return false;

  return summaryData.groups.some((group) =>
    group.banks?.some((bank) => {
      const showZeroRows = showZeroRowsMap[bank.bankCode] ?? false;
      const latestDateKey = summaryData?.dateColumns?.[0]?.key;

      const fullDataSource = bank.rows.map((row) => {
        const amountMap = {};
        summaryData.dateColumns.forEach((col) => {
          amountMap[col.key] = Number(row.balances?.[col.key] ?? 0);
        });
        return {
          latestBalance: Number(
            row.latestBalance ?? row.latestTotal ?? row.balances?.[latestDateKey] ?? 0,
          ),
          ...amountMap,
        };
      });

      const dataSource = showZeroRows
        ? fullDataSource
        : fullDataSource.filter((row) =>
            summaryData.dateColumns.some((col) => Number(row[col.key] ?? 0) !== 0),
          );

      return dataSource.length > 0;
    }),
  );
}, [summaryData, showZeroRowsMap]);

return (
  <div className="findash-page">
    <div
      className={`findash-content${filtersCollapsed ? " findash-content-collapsed" : ""}`}
    >
      {/* 左侧面板 */}
      {!filtersCollapsed && (
        <div className="findash-sidebar">
          {/* 头部：标题 + Hide 按钮 */}
          <div className="findash-filter-header">
            <span className="findash-panel-title">Report filters</span>
            <Button
              className="findash-collapse-btn"
              type="text"
              icon={<UpOutlined />}
              onClick={() => setFiltersCollapsed(true)}
            >
              Hide
            </Button>
          </div>

          <div className="findash-sidebar-inner">

            {/* Cycle Query */}
            <div className="findash-cycle-query">
              <div className="findash-section-title">Cycle Query</div>
              <Radio.Group
                value={dateType}
                onChange={(e) => setDateType(e.target.value)}
                className="findash-cycle-group"
              >
                <Radio.Button value="1" className="findash-cycle-btn">Day</Radio.Button>
                <Radio.Button value="2" className="findash-cycle-btn">Month</Radio.Button>
                <Radio.Button value="3" className="findash-cycle-btn">Quarter</Radio.Button>
              </Radio.Group>
            </div>

            {/* Group List Section */}
            <div className="findash-group-section">
              <div className="findash-group-header">
                <span className="findash-section-title">Saved List</span>
                <Button
                  type="link"
                  onClick={handleCreateGroup}
                  className="findash-group-create-btn"
                  icon={<span className="findash-plus-icon">+</span>}
                >
                  Create New List
                </Button>
              </div>

              <div className="findash-group-list">
                {groupLoading ? (
                  <div className="findash-loading-wrap">
                    <Spin size="small" />
                  </div>
                ) : (
                  <>
                    {groupList.length === 0 ? (
                      <div className="findash-empty-text">No groups yet</div>
                    ) : (
                      groupList.map((group) => (
                        <div
                          key={group.id}
                          className={`findash-group-item${
                            selectedGroupId === group.id ? " findash-group-item-active" : ""
                          }`}
                          onClick={() => handleGroupSelect(group.id, group.ownerIds)}
                        >
                          <div className="findash-group-item-left">
                            <Radio
                              checked={selectedGroupId === group.id}
                              onClick={(e) => e.stopPropagation()}
                              onChange={() => handleGroupSelect(group.id, group.ownerIds)}
                              className="findash-group-radio"
                            />
                            <div className="findash-group-info">
                              <div className="findash-group-name">
                                {group.groupName || `Group ${group.id}`}
                              </div>
                              <div className="findash-group-count">
                                {group.ownerIds?.length || 0} Owners
                              </div>
                            </div>
                          </div>

                          <Dropdown overlay={getGroupMenu(group)} trigger={["click"]}>
                            <Button
                              type="text"
                              size="small"
                              icon={<MoreOutlined />}
                              className="findash-group-more-btn"
                              onClick={(e) => e.stopPropagation()}
                            />
                          </Dropdown>
                        </div>
                      ))
                    )}
                  </>
                )}
              </div>
            </div>

            {/* Owner Section */}
            <div className="findash-owner-section">
              <div className="findash-owner-header">
                <span className="findash-section-title">Owner</span>
                <span className="findash-owner-count">
                  {selectedOwners.length} Selected
                </span>
              </div>
              <Input
                placeholder="Search Owner..."
                prefix={<SearchOutlined />}
                value={ownerSearchText}
                onChange={(e) => setOwnerSearchText(e.target.value)}
                className="findash-owner-search"
                allowClear
              />

              <div className="findash-owner-list">
                <Checkbox
                  checked={selectedOwners.includes("all")}
                  onChange={(e) => handleAllOwnersToggle(e.target.checked)}
                  className="findash-owner-all-checkbox"
                >
                  All Owners
                </Checkbox>
                {ownerLoading ? (
                  <div className="findash-loading-wrap">
                    <Spin size="small" />
                  </div>
                ) : (
                  filteredOwners.map((owner) => (
                    <div key={owner.ownerId} className="findash-owner-item">
                      <Checkbox
                        checked={selectedOwners.includes(owner.ownerId)}
                        onChange={() => handleOwnerToggle(owner.ownerId)}
                        disabled={selectedOwners.includes("all")}
                      >
                        {owner.name}
                      </Checkbox>
                    </div>
                  ))
                )}

                {!ownerLoading && filteredOwners.length === 0 && (
                  <div className="findash-empty-text">No owners found</div>
                )}
              </div>
            </div>

            <Button
              type="primary"
              loading={submitLoading}
              onClick={handleSubmit}
              className="findash-submit-btn"
            >
              Submit
            </Button>
          </div>
        </div>
      )}

 {/* 右侧表格区域 */}
   {filtersCollapsed && (
    <div className="findash-show-filters-row">
      <Button
        className="findash-collapse-btn"
        type="text"
        icon={<DownOutlined />}
        onClick={() => setFiltersCollapsed(false)}
      >
        Show filters
      </Button>
    </div>
  )}

<div className="findash-main">

  {/* 标题 */}
  <div className="findash-result-header">
    <span className="findash-panel-title">Report preview</span>
  </div>

  {/* 分割线 */}
  <div className="findash-result-divider" />

  {tabsItems.length > 0 && (
    <Tabs
      className="findash-tabs"
      activeKey={activeTab}
      onChange={(key) => {
        setActiveTab(key);
        setSummaryData(null);
        fetchSummary(key);
      }}
      items={tabsItems}
    />
  )}

<div className="findash-spin-wrapper">
  <Spin spinning={pageLoading} tip="Loading...">
    <div className="findash-scroll-wrapper">
      {!hasRenderableData ? (
        <div className="findash-empty-text findash-empty-result">
          No data
        </div>
      ) : (
        summaryData?.groups?.map((group) => {
          const bankViewList = group.banks
            .map((bank) => {
              const showZeroRows = showZeroRowsMap[bank.bankCode] ?? false;
              const latestDateKey = summaryData?.dateColumns?.[0]?.key;

              const fullDataSource = bank.rows.map((row, index) => {
                const amountMap = {};
                summaryData.dateColumns.forEach((col) => {
                  amountMap[col.key] = Number(row.balances?.[col.key] ?? 0);
                });
                return {
                  key: index,
                  index: index + 1,
                  entity: row.entity,
                  bankAccount: row.bankAccount,
                  remark: row.remark,
                  latestBalance: Number(
                    row.latestBalance ?? row.latestTotal ?? row.balances?.[latestDateKey] ?? 0,
                  ),
                  latestBalanceDate: row.latestBalanceDate ?? "",
                  ...amountMap,
                };
              });

              const dataSource = showZeroRows
                ? fullDataSource
                : fullDataSource.filter((row) =>
                    summaryData.dateColumns.some((col) => Number(row[col.key] ?? 0) !== 0),
                  );

              return { bank, showZeroRows, dataSource };
            })
            .filter((item) => item.dataSource.length > 0);

          return bankViewList.map(({ bank, showZeroRows, dataSource }, bankIndex) => {
            const isLastBank = bankIndex === bankViewList.length - 1;

            return (
              <div key={bank.bankCode} className="findash-bank-card">
                <div className="findash-bank-card-title">
                  <span>{bank.bankCode}</span>
                  <Button
                    size="small"
                    type="link"
                    onClick={() =>
                      setShowZeroRowsMap((prev) => ({
                        ...prev,
                        [bank.bankCode]: !showZeroRows,
                      }))
                    }
                  >
                    {showZeroRows ? "Hide zero balance rows" : "Show zero balance rows"}
                  </Button>
                </div>

                <Table
                  className="findash-table"
                  columns={columns}
                  dataSource={dataSource}
                  pagination={false}
                  loading={pageLoading}
                  tableLayout="auto"
                  scroll={{ x: "max-content" }}
                  locale={{ emptyText: "No data" }}
                  summary={() => (
                    <>
                      <Table.Summary.Row>
                        <Table.Summary.Cell colSpan={2} className="findash-summary-empty-cell" />
                        <Table.Summary.Cell className="findash-summary-title-cell">
                          Total Balance
                        </Table.Summary.Cell>

                        <Table.Summary.Cell align="center" className="findash-summary-amount-cell">
                          {commonFn.amountToDollarBracketFn(bank.bankLatestTotal ?? 0)}
                        </Table.Summary.Cell>
                        {visibleDateColumns.map((col) => (
                          <Table.Summary.Cell key={col.key} align="center" className="findash-summary-amount-cell">
                            {commonFn.amountToDollarBracketFn(bank.bankTotal?.[col.key] ?? 0)}
                          </Table.Summary.Cell>
                        ))}
                      </Table.Summary.Row>

                      {isLastBank && (
                        <Table.Summary.Row>
                          <Table.Summary.Cell colSpan={2} className="findash-summary-empty-cell findash-owner-total" />
                          <Table.Summary.Cell className="findash-summary-title-cell findash-owner-total">
                            Grand Total Balance
                          </Table.Summary.Cell>

                          <Table.Summary.Cell align="center" className="findash-summary-amount-cell findash-owner-total">
                            {commonFn.amountToDollarBracketFn(group.ownerLatestTotal ?? 0)}
                          </Table.Summary.Cell>
                          {visibleDateColumns.map((col) => (
                            <Table.Summary.Cell key={col.key} align="center" className="findash-summary-amount-cell findash-owner-total">
                              {commonFn.amountToDollarBracketFn(group.ownerTotal?.[col.key] ?? 0)}
                            </Table.Summary.Cell>
                          ))}
                        </Table.Summary.Row>
                      )}
                    </>
                  )}
                />
              </div>
            );
          });
        })
      )}
    </div>
  </Spin>
</div>
</div>
    </div>

    <GroupModal
      visible={groupModalVisible}
      onClose={handleCloseModal}
      onSuccess={fetchGroupList}
      ownerOptions={ownerOptions}
      editData={editGroupData}
      mode={modalMode}
    />
  </div>
);
};

export default FinancialDashboard;
